import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_pos-r _bgc--white _rounded--common gfu-background-swept" }
const _hoisted_2 = { class: "_flexcol _bxsh--base" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.itemsArray, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "_flex _ai-c _jc-sb _px-2 _py-2"
        }, [
          _createVNode(_component_skeleton_line, {
            height: 20,
            class: "_flex-basis-50"
          }),
          _createVNode(_component_skeleton_line, {
            height: 20,
            class: "_flex-basis-20"
          }),
          _createVNode(_component_skeleton_line, {
            height: 20,
            class: "_flex-basis-10"
          })
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}